import { Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import Config from "../../../../Config";

import AppSelectButton from "../../../component/app_select_button/app_select_button";
import AppTextField from "../../../component/app_text_field/app_text_field";
import "./proposal_form.css";
import AppCheckboxGroup from "../../../component/app_checkbox/app_checkbox";
import UtilBloc from "../../../../bloc/util_bloc";
import { numberValidation } from "../../../component/app_validation";
import FormsBloc from "../../../../bloc/forms_bloc";
class oilGasOccupationalQuestionnaire extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            displayOcc: '',
            oilGasOccupationData: {
                //form start
                occupation: null,
                exactDuties: null,
                workingDuration: null,
                isHazardousDuties: null,
                isJobScopeHeavy: "No",
                isJobScopeChemical: "No",
                isJobScopeEquipment: "No",
                isJobScopeExplosives: "No",
                isJobScopeVoltages: "No",
                isJobScopeUnderwater: "No",
                isJobScopeNo: "No",
                isAccident: null,
                rigLocation: null,
                travelFreqToRig: null,
                isHelicopter: "No",
                isOthers: "No",
                hazardousDetails: null,
                isAccidentDetails: null,
                isJobScopeHeavyDetails: null,
                isJobScopeChemicalDetails: null,
                isJobScopeEquipmentDetails: null,
                isJobScopeExplosivesDetails: null,
                isJobScopeVoltagesDetails: null,
                // isJobScopeUnderwaterDetails: null,
                helicopterToRigDuration: null,
                helicopterToRigFreq: null,
                otherDetails: null,
            },

            //form end
            jobScopeArry: [],
            transportModeArry: [],
            errorMessage: 'Fill in the required field.',
            isUpdate: false,
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
    }

    componentDidUpdate() {
        if (this.state.oilGasOccupationData.exactDuties != this.props.exactDuties) {
            this.handleValueChange(this.getFormFields().exactDuties, this.props.exactDuties);
        }
    }

    initiateData = async () => {
        let formData = this.props.value;
        let stateData = this.state.oilGasOccupationData;
        let occupation = null;
        await Promise.all(Object.keys(formData).map(async function (key) {
            stateData[key] = formData[key];
            if (key == 'occupation') {
                occupation = await FormsBloc.getOccupationNameByCode(formData[key]);
            }
        }));
        this.setState({ oilGasOccupationData: stateData, displayOcc: occupation });
    }

    //handle change start
    handleSetFormData = (item, idx) => {
        this.setState({
        })
    }

    //handle change start
    getFormFields() {
        return this.props.fields;
    }

    handleValueChange = (field, val) => {
        let data = this.state.oilGasOccupationData;
        data[field] = val
        this.setState({ oilGasOccupationData: data });
        this.onValidateForm();
    }

    handleCheckBoxValueChange = (field, val, childValue) => {
        if (val === true) {
            this.setState((prevState) => ({
                oilGasOccupationData: {
                    ...prevState.oilGasOccupationData,  // Maintain existing state
                    [field]: "Yes"
                }
            }), () => {
                this.onValidateForm();
            });
        } else {
            if (field == 'isJobScopeChemical' || field == 'isJobScopeHeavy' || field === 'isJobScopeEquipment' || field === 'isJobScopeExplosives' || field === 'isJobScopeVoltages') {
                this.setState((prevState) => ({
                    oilGasOccupationData: {
                        ...prevState.oilGasOccupationData,  // Maintain existing state
                        [field]: "No",
                        [`${field}Details`]: null
                    }
                }), () => {
                    this.onValidateForm();
                });

            } else if(field == 'isHelicopter'){
                this.setState((prevState) => ({
                    oilGasOccupationData: {
                        ...prevState.oilGasOccupationData,  // Maintain existing state
                        [field]: "No",
                        helicopterToRigDuration: null,
                        helicopterToRigFreq: null
                    }
                }), () => {
                    this.onValidateForm();
                });
            } else if(field == 'isOthers'){
                this.setState((prevState) => ({
                    oilGasOccupationData: {
                        ...prevState.oilGasOccupationData,  // Maintain existing state
                        [field]: "No",
                        otherDetails: null
                    }
                }), () => {
                    this.onValidateForm();
                });
            }else {
                this.setState((prevState) => ({
                    oilGasOccupationData: {
                        ...prevState.oilGasOccupationData,  // Maintain existing state
                        [field]: "No"
                    }
                }), () => {
                    this.onValidateForm();
                });
            }
        }
        if (childValue) {
            if (childValue === "All") {
                this.setState((prevState) => ({
                    isJobScopeHeavyDetails: null,
                    isJobScopeChemicalDetails: null,
                    isJobScopeEquipmentDetails: null,
                    isJobScopeExplosivesDetails: null,
                    isJobScopeVoltagesDetails: null,
                    // isJobScopeUnderwaterDetails: null,
                }), () => {
                    this.onValidateForm();
                });
                this.setState((prevState) => ({
                    oilGasOccupationData: {
                        ...prevState.oilGasOccupationData,  // Maintain existing state
                        isJobScopeHeavy: "No",
                        isJobScopeChemical: "No",
                        isJobScopeEquipment: "No",
                        isJobScopeExplosives: "No",
                        isJobScopeVoltages: "No",
                        isJobScopeUnderwater: "No",
                    }

                }), () => {
                    this.onValidateForm();
                });
            }
            else
                this.setState({ [childValue]: null })
        }
    }

    handleExtraFieldFormValueChange = (field, val) => {
        this.setState({ [field]: val }, () => {
            this.onValidateForm();
        });

    }

    onValidateForm = () => {
        const { oilGasOccupationData } = this.state;

        let validated = UtilBloc.oilGasOccupationDataValidation(oilGasOccupationData);

        this.setPropValidation(validated);
        this.setPropValue();
    }

    setPropValue = () => {
        const { oilGasOccupationData } = this.state;
        this.props.onChange(oilGasOccupationData);
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }


    async handleFormSubmit() {

    }

    showerror = (val) => {
        return val !== null && UtilBloc.isNullOrEmpty(val)
    }
    showExtraFormError = (parent, val, ind) => {
        if (parent === ind) {
            return val !== null && UtilBloc.isNullOrEmpty(val)
        }
        else
            return false
    }

    // form element start
    occupation() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.oilGassTitle.occupation}
                type={'text'}
                value={this.state.displayOcc}
                disabled={true}
            />
        )
    }
    exactDuties() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.oilGassTitle.exactDuties}
                type={'text'}
                multiline
                value={this.state.oilGasOccupationData.exactDuties}
                disabled={true}

            />
        )
    }
    workingDuration() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.oilGassTitle.workingDuration}
                type={'text'}
                placeholder={"00 years"}
                value={this.state.oilGasOccupationData.workingDuration}
                onChange={(e) => this.handleValueChange(this.getFormFields().workingDuration, e)}
                onValidate={(value) => { return !UtilBloc.isContainNumberOnly(value) }}
                errorMessage={numberValidation(this.state.oilGasOccupationData.workingDuration)}
            />
        )
    }

    jobScope() {
        return (
            <AppCheckboxGroup
                title={Config.proposal.formDataMapping.step1.oilGassTitle.jobScope}
                options={[
                    {
                        label: 'Lifting or moving heavey equipment?', value: 'Lifting or moving heavey equipment?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeHeavy,
                        checked: this.state.oilGasOccupationData.isJobScopeHeavy,
                        childValue: "isJobScopeHeavyDetails",
                        disabled: (this.state.oilGasOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please specify the type of equipment..."}
                                        value={this.state.oilGasOccupationData.isJobScopeHeavyDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isJobScopeHeavyDetails, e)}
                                        error={this.showExtraFormError(this.state.oilGasOccupationData.isJobScopeHeavy, this.state.oilGasOccupationData.isJobScopeHeavyDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Working with chemicals or gases?', value: 'Working with chemicals or gases?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeChemical,
                        checked: this.state.oilGasOccupationData.isJobScopeChemical,
                        childValue: "isJobScopeChemicalDetails",
                        disabled: (this.state.oilGasOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please specify the type of chemical/gases..."}
                                        value={this.state.oilGasOccupationData.isJobScopeChemicalDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isJobScopeChemicalDetails, e)}
                                        error={this.showExtraFormError(this.state.oilGasOccupationData.isJobScopeChemical, this.state.oilGasOccupationData.isJobScopeChemicalDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Working with any type of equipment?', value: 'Working with any type of equipment?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeEquipment,
                        checked: this.state.oilGasOccupationData.isJobScopeEquipment,
                        childValue: "isJobScopeEquipmentDetails",
                        disabled: (this.state.oilGasOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please specify the type of equipment..."}
                                        value={this.state.oilGasOccupationData.isJobScopeEquipmentDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isJobScopeEquipmentDetails, e)}
                                        error={this.showExtraFormError(this.state.oilGasOccupationData.isJobScopeEquipment, this.state.oilGasOccupationData.isJobScopeEquipmentDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Handling explosives?', value: 'Handling explosives?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeExplosives,
                        checked: this.state.oilGasOccupationData.isJobScopeExplosives,
                        childValue: "isJobScopeExplosivesDetails",
                        disabled: (this.state.oilGasOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please specify the type of explosives..."}
                                        value={this.state.oilGasOccupationData.isJobScopeExplosivesDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isJobScopeExplosivesDetails, e)}
                                        error={this.showExtraFormError(this.state.oilGasOccupationData.isJobScopeExplosives, this.state.oilGasOccupationData.isJobScopeExplosivesDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Handling high voltages?', value: 'Handling high voltages?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeVoltages,
                        checked: this.state.oilGasOccupationData.isJobScopeVoltages,
                        childValue: "isJobScopeVoltagesDetails",
                        disabled: (this.state.oilGasOccupationData.isJobScopeNo === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.oilGasOccupationData.isJobScopeVoltagesDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isJobScopeVoltagesDetails, e)}
                                        error={this.showExtraFormError(this.state.oilGasOccupationData.isJobScopeVoltages, this.state.oilGasOccupationData.isJobScopeVoltagesDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Underwater oil exploration?', value: 'Underwater oil exploration?',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isJobScopeUnderwater,
                        checked: this.state.oilGasOccupationData.isJobScopeUnderwater,
                        // childValue: "isJobScopeUnderwaterDetails",
                        disabled: (this.state.oilGasOccupationData.isJobScopeNo === "Yes"),
                        // children:
                        //     <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                        //         <div className="col-lg-12 col-sm-12  pl-0 pr-0">
                        //             <AppTextField
                        //                 type={'text'}
                        //                 multiline
                        //                 showCount
                        //                 maxLength={"1000"}
                        //                 placeholder={"Please specify the type of oil exploration..."}
                        //                 value={this.state.oilGasOccupationData.isJobScopeUnderwaterDetails}
                        //                 onChange={(e) => this.handleValueChange(this.getFormFields().isJobScopeUnderwaterDetails, e)}
                        //                 error={this.showExtraFormError(this.state.oilGasOccupationData.isJobScopeUnderwater, this.state.oilGasOccupationData.isJobScopeUnderwaterDetails, "Yes")}
                        //                 errorMessage={this.state.errorMessage}
                        //             />
                        //         </div>
                        //     </div>
                    },
                    {
                        label: 'Don\'t have any of these', value: 'Don\'t have any of these',
                        handleValueChange: this.handleCheckBoxValueChange,
                        childValue: "All",
                        getFormField: this.getFormFields()?.isJobScopeNo,
                        checked: this.state.oilGasOccupationData.isJobScopeNo,
                    },

                ]}
            />
        )
    }

    isHazardousDuties() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.oilGassTitle.isHazardousDuties}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            value={this.state.oilGasOccupationData.isHazardousDuties}
                            handleNegativePress={() =>{
                                let data = this.state.oilGasOccupationData;
                                data.hazardousDetails = null;
                                this.setState((prevState) => ({ oilGasOccupationData: data }), () => { this.handleValueChange(this.getFormFields().isHazardousDuties, 'No') })
                            }}
                            handlePositivePress={() => (this.handleValueChange(this.getFormFields().isHazardousDuties, 'Yes'))}
                        />
                    </div>
                </div>
            </div>
        )
    }
    hazardousDetails() {
        return (
            <AppTextField
                type={'text'}
                multiline
                showCount
                maxLength={"1000"}
                placeholder={"Please provide details..."}
                value={this.state.oilGasOccupationData.hazardousDetails}
                onChange={(e) => this.handleValueChange(this.getFormFields().hazardousDetails, e)}
                error={this.showExtraFormError(this.state.oilGasOccupationData.isHazardousDuties, this.state.oilGasOccupationData.hazardousDetails, "Yes")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    isAccident() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.oilGassTitle.isAccident}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            value={this.state.oilGasOccupationData.isAccident}
                            // handleNegativePress={() => this.handleValueChange(this.getFormFields().isAccident, 'No')}
                            handleNegativePress={() =>{
                                let data = this.state.oilGasOccupationData;
                                data.isAccidentDetails = null;
                                this.setState((prevState) => ({ oilGasOccupationData: data }), () => { this.handleValueChange(this.getFormFields().isAccident, 'No') })
                            }}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isAccident, 'Yes')}
                        />
                    </div></div>
            </div>
        )
    }
    isAccidentDetails() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.oilGassTitle.isAccidentDetails}
                type={'text'}
                multiline
                showCount
                maxLength={"1000"}
                placeholder={"Please state details..."}
                value={this.state.oilGasOccupationData.isAccidentDetails}
                onChange={(e) => this.handleValueChange(this.getFormFields().isAccidentDetails, e)}
                error={this.showExtraFormError(this.state.oilGasOccupationData.isAccident, this.state.oilGasOccupationData.isAccidentDetails, "Yes")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    rigLocation() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.oilGassTitle.rigLocation}
                type={'text'}
                placeholder={"Enter location of the rig..."}
                value={this.state.oilGasOccupationData.rigLocation}
                onChange={(e) => this.handleValueChange(this.getFormFields().rigLocation, e)}
                error={this.showerror(this.state.oilGasOccupationData.rigLocation)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    travelFreqToRig() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.oilGassTitle.travelFreqToRig}
                type={'text'}
                placeholder={"00 per annum"}
                value={this.state.oilGasOccupationData.travelFreqToRig}
                onChange={(e) => this.handleValueChange(this.getFormFields().travelFreqToRig, e)}
                onValidate={(value) => { return !UtilBloc.isContainNumberOnly(value) }}
                errorMessage={numberValidation(this.state.oilGasOccupationData.travelFreqToRig)}
            />
        )
    }

    transportMode() {
        return (
            <AppCheckboxGroup
                title={Config.proposal.formDataMapping.step1.oilGassTitle.transportMode}
                options={[
                    {
                        label: 'Helicopter', value: 'Helicopter',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isHelicopter,
                        checked: this.state.oilGasOccupationData.isHelicopter,
                        childValue: "helicopterToRigDuration",
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    <AppTextField
                                        title={Config.proposal.formDataMapping.step1.oilGassTitle.helicopterToRigDuration}
                                        type={'text'}
                                        placeholder={"00.00 hours"}
                                        value={this.state.oilGasOccupationData.helicopterToRigDuration}
                                        onValidate={(value) => { return !UtilBloc.isContainNumberOnly(value) }}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().helicopterToRigDuration, e)}
                                        // error={this.showExtraFormError(this.state.oilGasOccupationData.isHelicopter, this.state.oilGasOccupationData.helicopterToRigDuration, "Yes")}
                                        errorMessage={numberValidation(this.state.oilGasOccupationData.helicopterToRigDuration)}
                                    />
                                </div>
                                <div className="col-lg-6 col-sm-12 pr-0 pl-0">
                                    <AppTextField
                                        title={Config.proposal.formDataMapping.step1.oilGassTitle.helicopterToRigFreq}
                                        type={'text'}
                                        placeholder={"00 per annum"}
                                        value={this.state.oilGasOccupationData.helicopterToRigFreq}
                                        onValidate={(value) => { return !UtilBloc.isContainNumberOnly(value) }}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().helicopterToRigFreq, e)}
                                        // error={this.showExtraFormError(this.state.oilGasOccupationData.isHelicopter, this.state.oilGasOccupationData.helicopterToRigFreq, "Yes")}
                                        errorMessage={numberValidation(this.state.oilGasOccupationData.helicopterToRigFreq)}
                                    />
                                </div>
                            </div>

                    },
                    {
                        label: 'Others', value: 'Others',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields()?.isOthers,
                        checked: this.state.oilGasOccupationData.isOthers,
                        childValue: "otherDetails",
                        children:
                            <div className="col-lg-12 col-sm-12 pr-0 pl-0">
                                <AppTextField
                                    type={'text'}
                                    multiline
                                    showCount
                                    maxLength={1000}
                                    placeholder={"Please provide details..."}
                                    value={this.state.oilGasOccupationData.otherDetails}
                                    onChange={(e) => this.handleValueChange(this.getFormFields().otherDetails, e)}
                                    error={this.showExtraFormError(this.state.oilGasOccupationData.isOthers, this.state.oilGasOccupationData.otherDetails, "Yes")}
                                    errorMessage={this.state.errorMessage}
                                />
                            </div>
                    },
                ]}
            />
        )
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100 mt-4" >
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.occupation()}
                        </div>
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0">
                            {this.exactDuties()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.workingDuration()}
                        </div>
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                            {this.jobScope()}
                        </div>
                    </div>
                    <div className="mt-2">
                        {this.isHazardousDuties()}
                    </div>
                    {
                        this.state.oilGasOccupationData.isHazardousDuties === "Yes" &&
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                                {this.hazardousDetails()}
                            </div>
                        </div>
                    }
                    <div className="mt-2">
                        {this.isAccident()}
                    </div>
                    {
                        this.state.oilGasOccupationData.isAccident === "Yes" &&
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-12 col-sm-12 pr-3 pl-0">
                                {this.isAccidentDetails()}
                            </div>
                        </div>
                    }
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                            {this.rigLocation()}
                        </div>
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                            {this.travelFreqToRig()}
                        </div>
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                            {this.transportMode()}
                        </div>

                    </div>

                </div >
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(oilGasOccupationalQuestionnaire));
